// Mapping кодов сфер к именам полей в state
export const SPHERE_TYPE_STATE_MAPPING = {
	school: 'staffDeptTypeSchool',
	culture: 'staffDeptTypeCulture',
	sport: 'staffDeptTypeSport',
	healthcare: 'staffDeptTypeHealth',
}

export const SPHERE_ESTABLISHED_POST_STATE_MAPPING = {
	school: 'establishedPostBySchool',
	culture: 'establishedPostByCulture',
	sport: 'establishedPostBySport',
	healthcare: 'establishedPostByHealth',
}
